export default __webpack_public_path__ + "static/media/sign-in-background.a228ebfa.jpg";